import { Flex, NavigateButton } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTab } from '../../_components/HeaderTab';
import { DownloadOrganizationListCsvButton } from '../_components/DownloadOrganizationListCsvButton';
import { OrganizationSearchForm } from '../_components/OrganizationSearchForm';
import { OrganizationsTable } from '../_components/OrganizationsTable';

export const OrganizationsPage: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeaderTab
        type="organizations"
        tabBarExtraContent={
          <Flex gap={8}>
            <DownloadOrganizationListCsvButton />
            <TenantManagerResourceGuard onlyEdit>
              <NavigateButton path="new" text={t('create')} />
            </TenantManagerResourceGuard>
          </Flex>
        }
      />
      <OrganizationSearchForm />
      <OrganizationsTable />
    </>
  );
};
